import Select from "@ui-kit/form/Select/Select.web";
import Box from "@ui-kit/layout/Box/Box.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { useTranslation } from "@shared/utils/internationalization";
import { SeatPermissionSelectProps } from "./SeatPermissionSelect.props";
import { useSeatPermissionSelect } from "./useSeatPermissionSelect";

const SeatPermissionSelect = (props: SeatPermissionSelectProps) => {
  const { t } = useTranslation("seating");
  const { currentSeat } = props;
  const { selectedItem, getSelectOptions, onChangeItem } =
    useSeatPermissionSelect(props);

  return (
    <Box m="15px 0px">
      <Select
        id="select-seat-permission"
        ariaLabel="select option"
        placeholder={t("Select an Item")}
        variant="secondary"
        items={getSelectOptions(currentSeat)}
        selectedItem={selectedItem}
        isInvalid={!currentSeat.selectedPermission}
        onSelectedItemChange={({ selectedItem }) => {
          onChangeItem(selectedItem);
        }}
      />
      <Text
        mt="xs"
        fontSize="xs"
        color="secondary.600"
        hidden={Boolean(currentSeat.selectedPermission)}
      >
        {t("Please select an item for this seat.")}
      </Text>
    </Box>
  );
};

export default SeatPermissionSelect;
